module.exports = __webpack_public_path__ + "static/img/bjjtyy.b49759b.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bjjtyy.png
// module id = +u/k
// module chunks = 0